module.exports = __webpack_public_path__ + "static/quem-somos-livros-cf7a01a77747f15527fb1e23297c510a.jpg";